import { EditIcon, TrashIcon } from "@xola/icons";
import { Popover, Table } from "@xola/ui-kit";
import React from "react";
import { Schedule } from "types";
import { getScheduleSummary } from "../../helpers/scheduleSummaryHelper";
import { PriceVariationRange } from "../Product/SchedulesAvailability/PriceVariationRange";
import { ScheduleSummary } from "./ScheduleSummary";
import { SecondaryButton } from "./SecondaryButton";

interface ScheduleRowProps {
    schedule: any;
    setSelectedSchedule: (schedule: Schedule | null) => void;
    onRemove: (scheduleId: ID) => void;
    blackoutSchedules: boolean;
}

export const ScheduleRow = ({ schedule, setSelectedSchedule, onRemove, blackoutSchedules }: ScheduleRowProps) => {
    const name = schedule?.name?.trim()?.length > 0 ? schedule.name : getScheduleSummary(schedule);

    const handleDelete = async (e: any) => {
        e.stopPropagation();
        onRemove(schedule.id);
    };

    return (
        <Table.Row data-testid="schedule-row">
            <Table.Cell className="max-w-75 truncate">
                <Popover delay={0} distance={10} maxWidth={400} placement="left" skidding={0} trigger="mouseenter">
                    <u className="text-gray-darker">{name}</u>
                    <Popover.Content className="space-y-2 p-4">
                        <ScheduleSummary schedule={schedule} />
                    </Popover.Content>
                </Popover>
            </Table.Cell>
            {blackoutSchedules ? null : (
                <Table.Cell className="text-center" data-testid="schedule-row-price-variation-range">
                    <PriceVariationRange scheduleId={schedule.id} />
                </Table.Cell>
            )}
            <Table.Cell>
                <div className="flex items-center justify-end space-x-2">
                    <SecondaryButton
                        data-testid="schedule-row-edit-button"
                        size="tiny"
                        onClick={() => setSelectedSchedule(schedule)}
                    >
                        <EditIcon />
                    </SecondaryButton>
                    <SecondaryButton data-testid="schedule-row-delete-button" size="tiny" onClick={handleDelete}>
                        <TrashIcon />
                    </SecondaryButton>
                </div>
            </Table.Cell>
        </Table.Row>
    );
};
